<template>
  <div>
    <custom-callout :has-toggle="false" :has-border="false">
      <div class="row mt-2 mb-2">
        <div class="w-100">
          <em
            class="fas fa-calendar-alt rounded-circle text-orange p-2 bg-white shadow-icon"
          />
          <span class="ml-2 bold font-16">
            Calendario de Progreso Académico
          </span>
        </div>
      </div>

      <div class="mb-2  px-2" v-if="calendar.length > 0">
        <div class="row mt-3">
          <div class="col-10 offset-2">
            <p class="ml-2 bold">
              A continuación se detalla el calendario del proceso para someter
              notas por periodo y fecha de entrega de informe a los padres
            </p>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-2">
            <div class="row">
              <div class="col-6 col-md-3 d-flex flex-column"></div>
            </div>
          </div>
          <div class="col-10">
            <div class="row">
              <div class="col-6 col-md-5 d-flex flex-column">
                <custom-balloon
                  class="px-4 p-2 text-body"
                  :text="'Semana 10'"
                  :background-color="'blue square'"
                />
              </div>
              <div class="col-6 col-md-5 d-flex flex-column">
                <custom-balloon
                  class="px-4 p-2 text-body"
                  :text="'Semana 20'"
                  :background-color="'purple square'"
                />
              </div>
              <div class="col-6 col-md-5 d-flex flex-column">
                <custom-balloon
                  class="px-4 p-2 text-body"
                  :text="'Semana 30'"
                  :background-color="'pink square'"
                />
              </div>
              <div class="col-6 col-md-5 d-flex flex-column">
                <custom-balloon
                  class="px-4 p-2 text-body"
                  :text="'Semana 40'"
                  :background-color="'yellow square'"
                />
              </div>
              <div class="col-6 col-md-5 d-flex flex-column">
                <custom-balloon
                  class="px-4 p-2 text-body"
                  :text="'Semana 50 (AEE)'"
                  :background-color="'orange'"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2">
            <div class="row">
              <div class="bold">
                Fecha de Apertura:
              </div>
            </div>
          </div>
          <div class="col-10">
            <div class="row">
              <div
                class="col-6 col-md-5 d-flex flex-column"
                v-for="item in calendar"
              >
                <custom-balloon
                  class="px-4 p-2 text-body"
                  :text="startDate(item)"
                  :background-color="'default square'"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-2">
            <div class="row">
              <div class="bold">
                Fecha de entrega del informe a los padres:
              </div>
            </div>
          </div>
          <div class="col-10">
            <div class="row">
              <div
                class="col-6 col-md-5 d-flex flex-column"
                v-for="item in calendar"
              >
                <custom-balloon
                  class="px-4 p-2 text-body"
                  :text="reportDate(item)"
                  :background-color="'default square'"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </custom-callout>
  </div>
</template>
<script>
import CustomCallout from 'custom-callout';
import CustomBalloon from 'custom-balloon';
import peiAcademicProgressCalendar from '@/services/pei/peiAcademicProgressCalendar.js';
import moment from 'moment';

export default {
  name: 'AcademicProgressCalendar',
  components: {
    CustomCallout,
    CustomBalloon,
  },
  data: () => ({
    calendar: [],
  }),
  mounted() {
    Promise.all([this.getCalendar()]);
  },

  computed: {
    startDate() {
      return (item) =>
        moment(item.startDate)
          .locale('es')
          .format('DD') +
        ' de ' +
        moment(item.startDate)
          .locale('es')
          .format('MMMM');
    },
    reportDate() {
      return (item) =>
        moment(item.reportDate)
          .locale('es')
          .format('DD') +
        ' de ' +
        moment(item.reportDate)
          .locale('es')
          .format('MMMM');
    },
  },
  methods: {
    async getCalendar() {
      const { data } = await peiAcademicProgressCalendar.getCalendar();
      this.calendar = data;
    },
  },
};
</script>
<style lang="scss">
.balloon-container.blue {
  background-color: #7acbd0 !important;
}
.balloon-container.purple {
  background-color: #baa3e6 !important;
}
.balloon-container.default {
  background-color: #d9d9d9 !important;
}
.balloon-container.orange {
  background-color: #facfac !important;
}
.col-md-5 {
  width: 20%;
  float: left;
  flex: 0 0 20%;
  max-width: 20%;
}
.balloon-container.square {
  border-radius: 0;
  padding: 8px;
}
</style>
